// client/src/components/About.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import forImage from '../assets/for.webp';

const About = () => {
  const aboutImageStyle = {
    backgroundImage: `url(${forImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '350px',
    backgroundColor: '#ccc',
    borderRadius: '8px',
    boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
    flex: 1,
    width: '100%',
    minWidth: '300px'
  };

  return (
    <section className="about" id="about">
      <div className="container">
        <h2 className="section-title">О нашем отделении</h2>
        <div className="about-content">
          <div className="about-text">
            <h3>Более 25 лет боремся за интересы Нефтеюганцев</h3>
            <p>Нефтеюганское городское отделение Коммунистической партии Российской Федерации было создано в 1993 году и с тех пор ведет активную работу по защите социально-экономических прав жителей города и всего региона.</p>
            <p>Наши основные направления работы: защита трудовых прав, контроль за деятельностью властей, борьба с коррупцией, отстаивание интересов пенсионеров, молодежи, работников бюджетной сферы.</p>
            <p>Мы регулярно проводим приемы граждан, организуем общественный контроль за ценами и качеством услуг ЖКХ, выступаем с законодательными инициативами в органах местного самоуправления.</p>
            <Link to="/documents" className="btn" style={{ marginTop: '20px' }}>
              Наши документы и программа
            </Link>
          </div>
          <div className="about-image" style={aboutImageStyle}></div>
        </div>
      </div>
    </section>
  );
};

export default About;